import * as React from 'react';
import { scrollToAnchor } from '@cian/newbuilding-utils';
import { Label } from '@cian/ui-kit';
import { useSelector } from 'react-redux';

import { trackEscrowLabelClick, trackReliableLabelClick } from './tracking';
import {
  LabelsLayout,
  EscrowLabel,
  EscrowLabelTooltip,
  DiscountMortgageTooltip,
  ReliableLabelV2,
} from '../../components/Labels';
import {
  isEscrowSelector,
  getDiscountMortgage,
  getReliableLabel,
  getNewbuildingBrokerBookingAvailable,
} from '../../selectors/newbuilding';

export function LabelsContainer() {
  const hasDiscountMortgage = useSelector(getDiscountMortgage);
  const isEscrow = useSelector(isEscrowSelector);
  const reliableLabel = useSelector(getReliableLabel);
  const isBrokerBookingAvailable = useSelector(getNewbuildingBrokerBookingAvailable);

  const onReliableLabelClick = (event: React.MouseEvent<HTMLElement>) => {
    scrollToAnchor({
      anchor: '#reliable',
      offset: 0,
      hasRelocation: false,
      hasAnimation: true,
    })(event);
    trackReliableLabelClick();
  };

  const onEscrowLabelClick = (event: React.MouseEvent<HTMLElement>) => {
    scrollToAnchor({
      anchor: '#escrow',
      offset: 100,
      hasRelocation: false,
      hasAnimation: true,
    })(event);
    trackEscrowLabelClick();
  };

  return (
    <LabelsLayout>
      {hasDiscountMortgage && <DiscountMortgageTooltip />}
      {reliableLabel && (
        <ReliableLabelV2 label={reliableLabel.title} reliableType={reliableLabel.type} onClick={onReliableLabelClick} />
      )}
      {isEscrow && <EscrowLabelTooltip label={<EscrowLabel onClick={onEscrowLabelClick} />} />}
      {isBrokerBookingAvailable && (
        <Label color="accent-main-primary" background="accent-main-secondary">
          Онлайн-бронирование
        </Label>
      )}
    </LabelsLayout>
  );
}
